import {CURRENCY_ITEMS} from '../../../../../../constants';
import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import trim from 'mn-utils/trim';
import * as links from '../../../../../../constants/links';
import {
  pushLocation,
  backLocation,
} from '../../../../../../router';
import withState from '../../../../../../utils/withState';
import {
  apiAdminPayoutKrakenManualUpdate,
} from '../../../../../../api/admin/payout/kraken';
import {
  openV1PopupInfo,
} from '../../../../../../emitters/popup';
import LayoutB from '../../../../../dumb/Layout/B';
import CaptionA from '../../../../../dumb/Caption/A';
import HeaderA from '../../../../../dumb/Header/A';
import TextField from '../../../../../dumb/TextField/Reg2';
import ButtonJ from '../../../../../dumb/Button/J';
import Select from '../../../../../dumb/Select/E';
import ButtonBack from '../../../../../dumb/Button/Back';
import KeyboardDatePicker from '../../../../../dumb/KeyboardDatePicker/C';
import KeyboardTimePicker from '../../../../../dumb/KeyboardTimePicker/C';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';

module.exports = withState((setState) => {
  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeRefId = changeProvider('refId');
  const handleChangeKey = changeProvider('key');
  const handleChangeMethod = changeProvider('method');
  const handleChangeInfo = changeProvider('info');
  const handleChangeAmount = changeProvider('amount');
  const handleChangeFee = changeProvider('fee');
  const handleChangeTime = handleProvider('time');
  const handleChangeStatus = handleProvider('status');
  const handleChangeStatusProp = changeProvider('statusProp');

  return (state, props) => {
    const params = props.params || {};
    const {
      group_id: groupId,
      fiat_code: fiatCode,
    } = params;

    const clicked = state.clicked || false;

    const refId = state.refId || '';
    const _refId = trim(refId);
    const invalidRefId = !_refId;

    const key = state.key || '';
    const _key = trim(key);
    const invalidKey = !_key;

    const method = state.method || '';
    const _method = trim(method);
    const invalidMethod = !_method;

    const info = state.info || '';
    const _info = trim(info);
    const invalidInfo = !_info;

    const amount = state.amount || '';
    const _amount = trim(amount);
    const invalidAmount = !_amount;

    const fee = state.fee || '';
    const _fee = trim(fee);
    const invalidFee = !_fee;

    const time = state.time || '';
    const invalidTime = !time;

    const status = state.status || '';
    const _status = trim(status);
    const invalidStatus = !_status;

    const statusProp = state.statusProp || '';

    const disabled = invalidKey
      || invalidMethod
      || invalidInfo
      || invalidAmount
      || invalidFee
      || invalidTime
      || invalidStatus;

    return (
      <LayoutB>
        <HeaderA>
          <CaptionA
            className="fx1 wmin0"
            description={groupId}
          >
            Add manual transaction
          </CaptionA>
          <ButtonBack onClick={backLocation}/>
        </HeaderA>
        <WrapperWithLoading className="mt30" loading={state.loading}>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              className="mt20"
              label="Ref ID *"
              value={refId}
              error={clicked && invalidRefId}
              onChange={handleChangeRefId}
            />
            <TextField
              className="mt20"
              label="Key *"
              value={key}
              error={clicked && invalidKey}
              onChange={handleChangeKey}
            />
            <TextField
              className="mt20"
              label="Method *"
              value={method}
              error={clicked && invalidMethod}
              onChange={handleChangeMethod}
            />
            <div className="w mt20">
              <Select
                className="w"
                label="Asset *"
                placeholder="Asset *"
                propValue="id"
                propName="id"
                displayEmpty
                items={CURRENCY_ITEMS}
                value={fiatCode}
                disabled
              />
            </div>
            <TextField
              className="mt20"
              label="Info *"
              value={info}
              error={clicked && invalidInfo}
              onChange={handleChangeInfo}
            />
            <TextField
              className="mt20"
              label="Amount *"
              value={amount}
              error={clicked && invalidAmount}
              onChange={handleChangeAmount}
            />
            <TextField
              className="mt20"
              label="Fee *"
              value={fee}
              error={clicked && invalidFee}
              onChange={handleChangeFee}
            />
            <div className="w mt20 (lt|(w1/2)-10)>1">
              <KeyboardDatePicker
                className="mr10"
                label="Date *"
                disableFuture
                value={time}
                error={clicked && invalidTime}
                onChange={handleChangeTime}
              />
              <KeyboardTimePicker
                className="ml10"
                label="Time *"
                value={time}
                error={clicked && invalidTime}
                onChange={handleChangeTime}
              />
            </div>
            <div className="w mt20">
              <Select
                className="w"
                label="Status *"
                placeholder="Status *"
                error={clicked && invalidStatus}
                displayEmpty
                items={['Initial', 'Pending', 'Settled', 'Success', 'Failure']}
                value={status}
                onChange={handleChangeStatus}
              />
            </div>
            <TextField
              className="mt20"
              label="Status prop"
              value={statusProp}
              onChange={handleChangeStatusProp}
            />
          </div>

          <div className="pt90 layoutRow fhaB fvaC">
            <ButtonJ
              disabled={clicked && disabled}
              onClick={() => {
                if (disabled) {
                  setState({
                    clicked: true,
                  });
                  return;
                }
                setState({
                  loading: true,
                });

                const params = {
                  group_id: groupId,
                  payment_info: {
                    ref_id: refId,
                    key,
                    method,
                    asset: fiatCode,
                    info,
                    amount: Number(amount),
                    fee: Number(fee),
                    time,
                    status,
                    status_prop: statusProp,
                  },
                };

                apiAdminPayoutKrakenManualUpdate(params).finally((error) => {
                  setState({
                    loading: false,
                  });
                  error || (
                    pushLocation({
                      path: links.LINK_ADMIN_PAYOUT_NIUM_REMITTERS,
                    }),
                    openV1PopupInfo([
                      'Payout via Nium',
                      'Have been resented',
                    ])
                  );
                });
              }}
            >Send transaction</ButtonJ>
          </div>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
});
